'use strict';

import * as _ from 'lodash';
import angular from 'angular';

export class AuthService {
  constructor($cookies){
    this.$cookies = $cookies;
    this.isLoggedIn = () => {
      const result = this.$cookies.get('syncplicity_user');
      return result !== undefined;
    };

    this.destroySession = () => {
      this.$cookies.remove('syncplicity_user');
    };
  }
}

AuthService.$inject = ['$cookies'];

export default angular.module('services.auth', [])
  .service('authService', AuthService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/auth-service.js